/**
 * Rate It's "Solid" tier glyph — a single thumbs-up.
 *
 * Square (20x20), so one icon height renders it at that same width. Every `fill` is driven by
 * `col` so the tile can tint it, exactly as the app's other XML-string icon factories do.
 */
function Solid({ dimensions, col = '#FFFFFF' }) {
  const height = dimensions || 20;
  const width = (height * 20) / 20;

  return `
    <svg width="${width}" height="${height}" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.0007 8.00064L13.0008 3.88031C13.1138 3.42241 13.122 2.94488 13.0245 2.4834C12.9271 2.02192 12.7267 1.58843 12.4382 1.2153C12.1497 0.842174 11.7806 0.539066 11.3585 0.328622C10.9364 0.118179 10.4722 0.00584008 10.0006 0L6.5504 6.89055C6.38481 7.22379 6.12955 7.50423 5.81331 7.70034C5.49707 7.89644 5.13239 8.00044 4.76029 8.00064H2.00012C1.46966 8.00064 0.960917 8.21137 0.585822 8.58647C0.210726 8.96158 0 9.47032 0 10.0008V18.0014C0 18.5319 0.210726 19.0407 0.585822 19.4158C0.960917 19.7909 1.46966 20.0016 2.00012 20.0016H5.0003H15.5009C15.9337 20.0016 16.3548 19.8612 16.701 19.6016C17.0472 19.3419 17.2999 18.9769 17.4211 18.5615L19.7512 10.5608C19.8381 10.2628 19.8545 9.94851 19.7989 9.643C19.7434 9.33749 19.6175 9.04912 19.4312 8.8007C19.2449 8.55229 19.0033 8.35067 18.7256 8.2118C18.4478 8.07294 18.1416 8.00064 17.8311 8.00064H12.0007Z" fill="${col}"/>
    </svg>
  `;
}

export default Solid;
